import { render, staticRenderFns } from "./List_edit.vue?vue&type=template&id=76e2e272"
import script from "./List_edit.vue?vue&type=script&lang=js"
export * from "./List_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports